// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"AddOrEditModal--next-sr-only--1S4XpfU","formActionButtons":"AddOrEditModal--formActionButtons--mNorOoy"};